var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        "invalid-feedback": _vm.invalidFeedback,
        label: _vm.label,
        "label-for": _vm.formControlId,
      },
    },
    [
      _c(
        "textarea",
        {
          staticStyle: { display: "none" },
          attrs: { id: _vm.formControlId, name: _vm.formControlId },
          on: { change: _vm.handleChange },
        },
        [_vm._v("        " + _vm._s(_vm.data[_vm.property]) + "\n    ")]
      ),
      _vm._v(" "),
      _c("csp-ckeditor-reduced", {
        attrs: { "textarea-id": _vm.formControlId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }